/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduledSurveyGlobalResultsQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  filterAttributeIds?: Types.InputMaybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
  userGroupsUuids?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  writtenAs?: Types.InputMaybe<Types.CommentWrittenAs>;
}>;


export type ScheduledSurveyGlobalResultsQuery = { scheduledSurvey?: { id: number, isManualPublication: boolean, statistics_available_at?: string | undefined, schedulingId: number, status: { absolute: Types.Scheduled_Survey_Status, local: Types.Scheduled_Survey_Status }, beginAt: { local: string, earliest?: string | undefined, latest?: string | undefined }, endAt: { local: string, earliest?: string | undefined, latest?: string | undefined }, survey: { id: number, name: string, theme: { id: number, name: string, description: string, color: string, icon: string } }, questions: Array<{ id: number }>, statistics: { id: string, grade?: number | undefined, scheduledSurveyId?: number | undefined, submittedParticipationsCount: number, participationsPercentage: number, termsAcceptedRecipientsCount: number, adjustedParticipationsPercentage: number, recipientsCount: number, isClusterUnviolated: boolean, attributes: Array<{ isClusterUnviolated: boolean, usersCount: number, attribute: { name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> } }>, userGroups: Array<{ areRecipientsOverCluster: boolean, participationSubmittedNumber: number, userGroup: { name: string, uuid: string } }> }, comments: Array<{ id: number, comment: string, isAnonymous: boolean, objectId: number, objectType: Types.CommentObjectType, validatedAt?: string | undefined, publishedAt?: string | undefined, commentTranslations: Array<{ wording: string, language: { code: string, localizedLabel: string, translatedLabel: string } }>, attribute?: { name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> } | undefined, parentComment?: { id: number } | undefined, creator?: { id: number, email?: string | undefined, timezone: string, displayName: string, phone?: string | undefined, language: { code: string, localizedLabel: string, translatedLabel: string }, attributes: Array<{ name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> }> } | undefined }>, scopedComments: Array<{ id: number, comment: string, isAnonymous: boolean, objectId: number, objectType: Types.CommentObjectType, validatedAt?: string | undefined, publishedAt?: string | undefined, commentTranslations: Array<{ wording: string, language: { code: string, localizedLabel: string, translatedLabel: string } }>, attribute?: { name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> } | undefined, parentComment?: { id: number } | undefined, creator?: { id: number, email?: string | undefined, timezone: string, displayName: string, phone?: string | undefined, language: { code: string, localizedLabel: string, translatedLabel: string }, attributes: Array<{ name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> }> } | undefined }>, userGroups: Array<{ uuid: string, usersCount?: number | undefined, name: string, createdAt: string, deletedAt?: string | undefined, users: Array<{ first_name: string, last_name: string, email?: string | undefined, phone_number?: string | undefined, id: number }> }> } | undefined };


export const ScheduledSurveyGlobalResultsDocument = gql`
    query ScheduledSurveyGlobalResults($id: Int!, $filterAttributeIds: [Int!], $userGroupsUuids: [String!], $writtenAs: CommentWrittenAs) {
  scheduledSurvey: scheduled_survey(scheduled_survey_id: $id) {
    id
    schedulingId: id
    status {
      absolute
      local
    }
    beginAt: begin_at {
      local
      earliest
      latest
    }
    endAt: end_at {
      local
      earliest
      latest
    }
    isManualPublication
    statistics_available_at
    survey {
      id
      name
      theme {
        id
        name
        description
        color
        icon
      }
    }
    questions: ordered_questions {
      id
    }
    statistics: detailedStatistics(attribute_ids: $filterAttributeIds, userGroupUuids: $userGroupsUuids) {
      id
      scheduledSurveyId: scheduled_survey_id
      submittedParticipationsCount: participation_submitted_number
      participationsPercentage: real_participation_percentage
      termsAcceptedRecipientsCount: recipient_who_accepted_tos_number
      adjustedParticipationsPercentage: adjust_participation_percentage
      recipientsCount: recipient_number
      grade
      isClusterUnviolated: are_participations_above_cluster
      attributes: statistics_attributes {
        isClusterUnviolated: are_recipients_above_cluster
        usersCount: recipient_number
        attribute {
          valueId: id
          attributeId: name_id
          name
          value
          isMainHierarchyHead: is_hierarchy_head
          parent {
            attributeId: name_id
            valueId: id
          }
          children {
            attributeId: name_id
            valueId: id
          }
        }
      }
      userGroups: statisticsUserGroup {
        areRecipientsOverCluster
        participationSubmittedNumber
        userGroup {
          name
          uuid
        }
      }
    }
    comments(limit: 1, writtenAs: $writtenAs) {
      id
      comment
      commentTranslations: comment_translations {
        wording
        language {
          code
          localizedLabel: localized_label
          translatedLabel: translated_label
        }
      }
      attribute {
        valueId: id
        attributeId: name_id
        name
        value
        isMainHierarchyHead: is_hierarchy_head
        parent {
          attributeId: name_id
          valueId: id
        }
        children {
          attributeId: name_id
          valueId: id
        }
      }
      isAnonymous: is_anonymous
      objectId: object_id
      objectType: object_type
      validatedAt: validated_at
      publishedAt: published_at
      parentComment: parent_comment {
        id
      }
      creator {
        id
        displayName: display_name
        email
        phone: phone_number
        language {
          code
          localizedLabel: localized_label
          translatedLabel: translated_label
        }
        timezone
        attributes {
          valueId: id
          attributeId: name_id
          name
          value
          isMainHierarchyHead: is_hierarchy_head
          parent {
            attributeId: name_id
            valueId: id
          }
          children {
            attributeId: name_id
            valueId: id
          }
        }
      }
    }
    scopedComments: scoped_comments(limit: 1000, writtenAs: $writtenAs) {
      id
      comment
      commentTranslations: comment_translations {
        wording
        language {
          code
          localizedLabel: localized_label
          translatedLabel: translated_label
        }
      }
      attribute {
        valueId: id
        attributeId: name_id
        name
        value
        isMainHierarchyHead: is_hierarchy_head
        parent {
          attributeId: name_id
          valueId: id
        }
        children {
          attributeId: name_id
          valueId: id
        }
      }
      isAnonymous: is_anonymous
      objectId: object_id
      objectType: object_type
      validatedAt: validated_at
      publishedAt: published_at
      parentComment: parent_comment {
        id
      }
      creator {
        id
        displayName: display_name
        email
        phone: phone_number
        language {
          code
          localizedLabel: localized_label
          translatedLabel: translated_label
        }
        timezone
        attributes {
          valueId: id
          attributeId: name_id
          name
          value
          isMainHierarchyHead: is_hierarchy_head
          parent {
            attributeId: name_id
            valueId: id
          }
          children {
            attributeId: name_id
            valueId: id
          }
        }
      }
    }
    userGroups {
      uuid
      usersCount
      name
      createdAt
      deletedAt
      users {
        first_name
        last_name
        email
        phone_number
        id
      }
    }
  }
}
    `;

/**
 * __useScheduledSurveyGlobalResultsQuery__
 *
 * To run a query within a React component, call `useScheduledSurveyGlobalResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledSurveyGlobalResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledSurveyGlobalResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filterAttributeIds: // value for 'filterAttributeIds'
 *      userGroupsUuids: // value for 'userGroupsUuids'
 *      writtenAs: // value for 'writtenAs'
 *   },
 * });
 */
export function useScheduledSurveyGlobalResultsQuery(baseOptions: Apollo.QueryHookOptions<ScheduledSurveyGlobalResultsQuery, ScheduledSurveyGlobalResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledSurveyGlobalResultsQuery, ScheduledSurveyGlobalResultsQueryVariables>(ScheduledSurveyGlobalResultsDocument, options);
      }
export function useScheduledSurveyGlobalResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledSurveyGlobalResultsQuery, ScheduledSurveyGlobalResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledSurveyGlobalResultsQuery, ScheduledSurveyGlobalResultsQueryVariables>(ScheduledSurveyGlobalResultsDocument, options);
        }
export type ScheduledSurveyGlobalResultsQueryHookResult = ReturnType<typeof useScheduledSurveyGlobalResultsQuery>;
export type ScheduledSurveyGlobalResultsLazyQueryHookResult = ReturnType<typeof useScheduledSurveyGlobalResultsLazyQuery>;
export type ScheduledSurveyGlobalResultsQueryResult = Apollo.QueryResult<ScheduledSurveyGlobalResultsQuery, ScheduledSurveyGlobalResultsQueryVariables>;
